import type { AxiosRequestHeaders, RawAxiosResponseHeaders } from "axios";
import axios from "axios";
import saveAs from "file-saver";
import { logError } from "../logging";
import { wait } from "../utilities/promiseHelper";

export const downloadFileFromUrl = async (url: string) => {
  try {
    const a = document.createElement("a");
    a.href = url;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    await wait(500); // Let download start to prevent issues with subsequent HTTP requests
    document.body.removeChild(a);
  } catch (error) {
    logError(error, `[downloadFileFromUrl] URL: ${url}`);
  }
};

const tryGetFileNameFromHeaders = (respHeaders: RawAxiosResponseHeaders) => {
  const contentDisposition = respHeaders["content-disposition"];
  if (typeof contentDisposition === "string") {
    const matches = contentDisposition.match(/filename=(.+);/);
    if (matches) {
      return matches[1];
    }
  }

  return undefined;
};

const tryGetFileNameFromUrl = (url: string) => {
  const pathName = decodeURI(new URL(url).pathname);
  return pathName.split("/").pop() || "";
};

export const downloadFileFromUrlViaAxios = async (url: string, filename?: string, headers?: AxiosRequestHeaders) => {
  const response = await axios.get(url, { responseType: "blob", headers });
  const fileName = filename || tryGetFileNameFromHeaders(response.headers) || tryGetFileNameFromUrl(url);
  const contentType = (response.headers["content-type"] as string) || "application/octet-stream";
  const blob = new Blob([response.data], { type: contentType });
  saveAs(blob, fileName);
};

export const saveCsvFile = (csv: string, fileName: string) => {
  const csvWithBom = "\uFEFF" + csv; // for Excel fans
  const blob = new Blob([csvWithBom], { type: "text/csv;charset=utf-8;" });
  saveAs(blob, fileName);
};
